class PADriverYearLicensedCtrl {

    constructor($scope, AgeAllowedToDrive, editableDriverDOB) {
        const startingYear = new Date();

        $scope.editableDriverDOB = editableDriverDOB;
        $scope.maxDateOfBirth = {
            year: startingYear.getFullYear() - AgeAllowedToDrive,
            month: startingYear.getMonth(),
            day: startingYear.getDate()
        };

        $scope.years = [];
        const currentYear = new Date().getUTCFullYear();

        $scope.setYears = (earliestYear) => {
            $scope.years.length = 0;
            for (let i = currentYear - earliestYear; i <= currentYear; i++) {
                $scope.years.unshift(i);
                if (i === currentYear) {
                    // last iteration of loop, if user has changed their dob to be after year first licensed
                    // make sure that the yearLicensed previously chosen is still valid.
                    if ($scope.model.value && $scope.model.yearLicensed.value &&
                        $scope.years.indexOf($scope.model.yearLicensed.value) === -1) {
                        $scope.model.yearLicensed.value = undefined;
                    }
                }
            }
        };

        if ($scope.model.value && $scope.model.dateOfBirth.value) {
            const dobDate = $scope.model.dateOfBirth.value;
            $scope.setYears(currentYear - (dobDate.year + AgeAllowedToDrive));
        } else {
            $scope.setYears(AgeAllowedToDrive);
        }
    }
}

PADriverYearLicensedCtrl.$inject = ['$scope', 'AgeAllowedToDrive', 'pa.qnb.editableDriverDOB'];

export default PADriverYearLicensedCtrl;